module.exports = __webpack_public_path__ + "img/v_ileti.35a198d4.svg";